import React from 'react';
import { motion } from 'framer-motion';
const WHATSAPP_NUMBER = '541153399780';
const PREFILLED_MESSAGE = 'Hola, quiero información del Mega Pack Maestro de Gemoterapia 🔮';
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(PREFILLED_MESSAGE)}`;
const WhatsAppGlyph = ({
  className = ''
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className} data-id="element-293" data-mp="2267va6x66o1n">
    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.46 1.32 4.96L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91C21.96 6.45 17.5 2 12.04 2Zm0 18.02h-.01a8.2 8.2 0 0 1-4.18-1.15l-.3-.18-3.11.82.83-3.04-.19-.31a8.19 8.19 0 0 1-1.26-4.35c0-4.54 3.7-8.23 8.24-8.23 2.2 0 4.26.86 5.82 2.41a8.18 8.18 0 0 1 2.41 5.83c0 4.54-3.7 8.2-8.25 8.2Zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.25-.64.81-.79.97-.14.17-.29.19-.54.06-.25-.12-1.06-.39-2.02-1.25-.75-.66-1.25-1.48-1.4-1.73-.14-.25-.01-.39.11-.51.11-.11.25-.29.37-.44.13-.14.17-.25.25-.41.08-.17.04-.31-.02-.44-.06-.12-.55-1.34-.76-1.83-.2-.48-.4-.42-.55-.42h-.47c-.16 0-.42.06-.64.31-.22.25-.84.82-.84 2 0 1.18.86 2.32.98 2.48.12.17 1.68 2.57 4.07 3.6.57.25 1.01.39 1.36.5.57.18 1.09.16 1.5.1.46-.07 1.42-.58 1.62-1.14.2-.56.2-1.04.14-1.14-.06-.1-.22-.16-.47-.29Z" data-id="element-294" data-mp="1eesnhymmjej0" />
  </svg>;
export function WhatsAppButton() {
  return <motion.a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" aria-label="Escribinos por WhatsApp" initial={{
    opacity: 0,
    scale: 0.8,
    y: 12
  }} animate={{
    opacity: 1,
    scale: 1,
    y: 0
  }} transition={{
    delay: 1.2,
    type: 'spring',
    stiffness: 320,
    damping: 22
  }} whileHover={{
    scale: 1.06
  }} whileTap={{
    scale: 0.95
  }} className="group fixed bottom-5 right-5 z-[60] flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 text-white shadow-[0_10px_28px_rgba(42,18,89,.32)] ring-2 ring-white/70 focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-goldBright md:bottom-8 md:right-8" data-id="element-295" data-mp="3lrhwy1so42mi">
      <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#25D366]/40" data-id="element-296" data-mp="e620jtb2p98v" />
      <WhatsAppGlyph className="h-6 w-6 md:h-7 md:w-7" data-id="element-297" data-mp="98s3brhfztah" />
      <span className="hidden text-sm font-bold md:inline" data-id="element-298" data-mp="ny7qyylofily">Consultar por WhatsApp</span>
    </motion.a>;
}